export default __webpack_public_path__ + "static/media/info-icon.a596c2dd.svg";